/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_Tab_Coach_UnreadInputs */

const en_us2_shell_tab_coach_unread = /** @type {(inputs: Shell_Tab_Coach_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainer: new reply`)
};

const pt_br2_shell_tab_coach_unread = /** @type {(inputs: Shell_Tab_Coach_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal: resposta nova`)
};

const es_419_shell_tab_coach_unread = /** @type {(inputs: Shell_Tab_Coach_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenador: respuesta nueva`)
};

const pt_pt2_shell_tab_coach_unread = /** @type {(inputs: Shell_Tab_Coach_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinador: resposta nova`)
};

const fr_fr2_shell_tab_coach_unread = /** @type {(inputs: Shell_Tab_Coach_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach : nouvelle réponse`)
};

const de_de2_shell_tab_coach_unread = /** @type {(inputs: Shell_Tab_Coach_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach: neue Antwort`)
};

const it_it2_shell_tab_coach_unread = /** @type {(inputs: Shell_Tab_Coach_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach: nuova risposta`)
};

/**
* | output |
* | --- |
* | "Trainer: new reply" |
*
* @param {Shell_Tab_Coach_UnreadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_tab_coach_unread = /** @type {((inputs?: Shell_Tab_Coach_UnreadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Tab_Coach_UnreadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_tab_coach_unread(inputs)
	if (locale === "es-419") return es_419_shell_tab_coach_unread(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_tab_coach_unread(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_tab_coach_unread(inputs)
	if (locale === "de-DE") return de_de2_shell_tab_coach_unread(inputs)
	if (locale === "it-IT") return it_it2_shell_tab_coach_unread(inputs)
	return en_us2_shell_tab_coach_unread(inputs)
});
export { shell_tab_coach_unread as "shell.tab_coach_unread" }